(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-brand"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('shopByBrandSearch');
    if (!input) return;
    input.addEventListener('keyup', function () {
      var term = input.value.toLowerCase();
      var cards = document.querySelectorAll('.shop-by-brand-card');
      var visible = 0;
      cards.forEach(function (card) {
        var name = card.getAttribute('data-brand') || '';
        if (name.indexOf(term) !== -1) { card.style.display = ''; visible++; }
        else { card.style.display = 'none'; }
      });
      var nores = document.getElementById('shopByBrandNoResults');
      if (nores) nores.style.display = (visible === 0) ? 'block' : 'none';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
